.styledCheckBox {
  cursor: pointer;
  width: 20px;
  height: 20px;

  [data-checkmark] {
    margin-top: -1px;
    width: 20px;
    height: 20px;
  }

  [data-check-icon] {
    width: 20px;
    height: 20px;
  }
}
